"use client";

import { BlogLink, Content, Header } from "@/components/shared/public/blogs";
import { useTranslations } from "next-intl";
import {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
} from "../../../../../../public/images/blogs/constructionPlan";

export default function BlogContent() {
  const t = useTranslations("blogs.constructionPlan");

  return (
    <>
      <Header
        title={t("header.title")}
        text={t("header.text")}
        src={header}
        alt={t("header.imageAlt")}
      />
      <div className="gs--blog-body flex flex-col gap-10 py-16">
        <Content
          imageFit="cover"
          title={t("sections.section1.title")}
          text={t.rich("sections.section1.text", {
            br: () => <br></br>,
          })}
          src={section1}
          alt={t("sections.section1.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section2.title")}
          text={t.rich("sections.section2.text", {
            br: () => <br></br>,
            link1: (chunk) => <BlogLink href="/blog/grundriss">{chunk}</BlogLink>,
          })}
          src={section2}
          alt={t("sections.section2.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section3.title")}
          text={t.rich("sections.section3.text", {
            br: () => <br></br>,
            ul: () => (
              <ul>
                {(t.raw("sections.section3.list") as string[]).map(
                  (item, i) => (
                    <li key={i}>{item}</li>
                  ),
                )}
              </ul>
            ),
          })}
          src={section3}
          alt={t("sections.section3.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section4.title")}
          text={t.rich("sections.section4.text", {
            br: () => <br></br>,
            ul: () => (
              <ul>
                <li>{t("sections.section4.list.0")}</li>
                <li>{t("sections.section4.list.1")}</li>
                <li>
                  {t.rich("sections.section4.list.2", {
                    link1: (chunk) => (
                      <BlogLink href="/blog/wohnflaechenberechnung-din277">
                        {chunk}
                      </BlogLink>
                    ),
                  })}
                </li>
                <li>{t("sections.section4.list.3")}</li>
                <li>{t("sections.section4.list.4")}</li>
              </ul>
            ),
          })}
          src={section4}
          alt={t("sections.section4.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section5.title")}
          text={t.rich("sections.section5.text", {
            br: () => <br></br>,
            link1: (chunk) => (
              <BlogLink href="/verkaufsoptimierte-grundrisse">
                {chunk}
              </BlogLink>
            ),
            link2: (chunk) => (
              <BlogLink href="/blog/bemasster-grundriss">{chunk}</BlogLink>
            ),
          })}
          src={section5}
          alt={t("sections.section5.imageAlt")}
          imageLeft={true}
          disclaimer="default"
        />
      </div>
    </>
  );
}
